import { BASE_URL } from "../constants/Endpoints"
import axios from "axios";

export class InviaAffidaService {
    base(path) { return `${BASE_URL}/api-v1/people/invia-affida/${path}` }

    async send(contactId) {
        return await axios.post(
            this.base('send'),
            { contact_id: contactId },
            { withCredentials: true },
        ).then(r => r.data);
    }

    async listForContact(contactId) {
        return await axios.get(
            `${BASE_URL}/api-v1/people/invia-affida/list`,
            { params: { contact_id: contactId }, withCredentials: true },
        ).then(r => r.data);
    }
}
